/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

'use strict';

function isValidEmailRequest(mailerResponse) {
    return Odigeo._.isObject(mailerResponse) && Odigeo._.contains(['SENT', 'QUEUED'], mailerResponse.status);
}

module.exports = Odigeo.Model.extend({
    defaults: {
        captchaEnabled: false,
    },
    dataURL: 'send',

    url: function() {
        return Odigeo.Settings.getProperty('emailServiceUrlFormmater')(this.dataURL);
    },

    sendLinkByEmail: function(data) {
        return this.fetch({
            data: JSON.stringify(data),
            dataType: 'json',
            contentType: 'application/json',
            type: 'POST',
            success: Odigeo._.bind(this.requestSuccessHandler, this),
            error: Odigeo._.bind(this.requestErrorHandler, this),
        });
    },

    requestSuccessHandler: function(model, response) {
        if (isValidEmailRequest(response)) {
            this.trigger('emailSent');
        } else {
            this.requestErrorHandler();
        }
    },

    requestErrorHandler: function() {
        this.trigger('emailSentError');
    },

    reset: function(attributes) {
        var keepValues = Odigeo._.pick(this.attributes, 'reCaptchaWidgetId', 'captchaEnabled');
        this.clear().set(Odigeo._.extend(attributes, keepValues)).trigger('resetShare');
    },
});
